import * as moment from 'moment'
import * as React from 'react'
import { connect } from 'react-redux'
import { Operation } from '../../domain/Operation'
import { TracepointRule } from '../../domain/TracepointRule'
import Countdown from '../../helper/countdown'
import Link from '../../helper/link'
import { ApplicationState } from '../../redux/ApplicationState'
import { ContextState } from '../../redux/context/ContextState'
import { FetchTracepointParameters, fetchTracepoints } from '../../redux/V2/TracepointRule/actions'
import {
    areTracepointRulesLoaded,
    getActiveTracepointRuleForTransaction,
    getNumberOfActiveTracepoints,
} from '../../redux/V2/TracepointRule/TracepointRuleState'

interface OwnProps {
    operation: Operation
    maxConcurrent: number
    onAdd: (errorMessage: string | null) => void
    small: boolean
    service: string
    environment: string
}

interface StateProps {
    tidewaysContext: ContextState
    tracepoints: Array<TracepointRule<moment.Moment>>
    tracepointsLoaded: boolean
    activeBoosts: number
}

interface DispatchProps {
    fetchTracepoints: (params: FetchTracepointParameters) => void
}

type Props = DispatchProps & StateProps & OwnProps

class Tracepoint extends React.Component<Props> {
    public static defaultProps = {
        small: true,
    }

    public componentDidMount() {
        const { environment, service } = this.props.tidewaysContext
        this.props.fetchTracepoints({ environment, service })
    }

    public componentDidUpdate(prevProps: Props) {
        const { environment, service } = this.props.tidewaysContext
        if (prevProps.tidewaysContext.environment === environment && prevProps.tidewaysContext.service === service) {
            return
        }

        this.props.fetchTracepoints({ environment, service })
    }

    public render() {
        if (!this.props.tracepointsLoaded) {
            return null
        }

        const { environment, service } = this.props.tidewaysContext

        const classesActive = this.props.small
            ? 'btn btn-sm btn-outline-burning dropdown-toggle'
            : 'btn btn-outline-burning dropdown-toggle'

        if (this.props.tracepoints.length > 0) {
            return this.props.tracepoints.map((tracepoint: TracepointRule<moment.Moment>) => {
                return (
                    <Link
                        route="XhprofProfilerBundle.Profile.tracepoint"
                        className={classesActive}
                        key={tracepoint.id}
                        style={{ marginLeft: '1em' }}
                        params={{ tracepointId: tracepoint.id, sortBy: 'wt' }}
                    >
                        <i className="fa fa-crosshairs" /> <b>Tracepoint Active</b>
                        {!tracepoint.editable && tracepoint.generatedBy === 'user' ? ` (user: ${tracepoint.user})` : null}&nbsp;
                        {tracepoint.generatedBy !== 'user' && <>(automatic)</>}
                        <Countdown
                            className="weight-normal"
                            countdownEnd={tracepoint.activeUntil}
                            onComplete={() => this.props.fetchTracepoints({ environment, service })}
                        />
                    </Link>
                )
            })
        }

        return (
            <button
                className={this.props.small ? 'btn btn-sm btn-primary' : 'btn btn-primary'}
                style={{ marginLeft: '1em' }}
                onClick={() => this.props.onAdd(this.errorMessage())}
                title="boost trace rate for this transaction"
            >
                <i className="fa fa-crosshairs" /> Boost Traces
            </button>
        )
    }

    public errorMessage = (): string | null => {
        const { activeBoosts, maxConcurrent } = this.props

        if (activeBoosts >= maxConcurrent) {
            return (
                `This application is at the limit of ${maxConcurrent} active Tracepoint(s). ` +
                `You need to wait for the Tracepoint(s) to finish before creating another one.`
            )
        }

        return null
    }
}

export default connect<StateProps, DispatchProps>(
    (globalState: ApplicationState, props: Props): StateProps => {
        return {
            tidewaysContext: globalState.tidewaysContext,
            tracepoints: getActiveTracepointRuleForTransaction(globalState, props.operation),
            tracepointsLoaded: areTracepointRulesLoaded(globalState),
            activeBoosts: getNumberOfActiveTracepoints(globalState),
        }
    },
    {
        fetchTracepoints,
    },
)(Tracepoint)
